import { ExclamationTriangleIcon } from '@radix-ui/react-icons'

export interface InfoBannerData {
  id: string
  message: string
}

interface InfoBannerProps {
  banners: InfoBannerData[]
}

/**
 * InfoBanner component displays important messages to all users.
 * Shows active banners that are within their display time window.
 * Multiple banners are stacked vertically.
 */
export function InfoBanner({ banners }: InfoBannerProps) {
  if (!banners || banners.length === 0) {
    return null
  }

  return (
    <>
      {banners.map(banner => (
        <div
          key={banner.id}
          role="status"
          aria-live="polite"
          className="flex w-full justify-center bg-blue-50 px-4 py-2 dark:bg-blue-950"
        >
          <div className="flex max-w-4xl items-start gap-2 text-sm text-blue-800 dark:text-blue-200">
            <ExclamationTriangleIcon className="mt-0.5 h-4 w-4 shrink-0" />
            <span className="text-left">{banner.message}</span>
          </div>
        </div>
      ))}
    </>
  )
}

